export default `
      <link href='/snippets-style/footerSocials.css' rel='stylesheet' />
    <div class="footer-socials">
       <div class="footer-socials__title">We are in social networks</div>
       <ul class="footer-socials__list">
          <li><a href="https://www.facebook.com/favbet.ro" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/socials/facebook.svg" alt="Facebook"></a></li>
          <li><a href="https://www.instagram.com/favbet.ro" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/socials/instagram.svg" alt="Instagram"></a></li>
       </ul>
    </div>
`;
